/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The RefWordVo model module.
   * @module drill/model/RefWordVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>RefWordVo</code>.
   * @alias module:drill/model/RefWordVo
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>RefWordVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/RefWordVo} obj Optional instance to populate.
   * @return {module:drill/model/RefWordVo} The populated <code>RefWordVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'word')) {
        obj['word'] = ApiClient.convertToType(data['word'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pron')) {
        obj['pron'] = ApiClient.convertToType(data['pron'], [['String']]);
      }
    }
    return obj;
  }

  /**
   * 当前词
   * @member {String} word
   */
  exports.prototype['word'] = undefined;
  /**
   * @member {Array.<Array.<String>>} pron
   */
  exports.prototype['pron'] = undefined;



  export default exports;
;


